// ฟังก์ชันตรวจสอบการแสดง Popup
export const checkShowPopup = (response) => {
  if (!response || !response.data) return false;

  const contestData = response.data;

  // เช็คว่าเคยกดปิดไปแล้วหรือยัง
  const lastShow = localStorage.getItem("contestPopupLastShow");
  if (lastShow) {
    const now = Date.now(); // ใช้ timestamp
    const lastShowTime = new Date(lastShow).getTime();

    // ถ้าเวลาที่บันทึกอยู่ในอนาคต ให้ลบและเริ่มใหม่
    if (lastShowTime > now) {
      localStorage.removeItem("contestPopupLastShow");
      return true;
    }
    const timeSinceLastShow = now - lastShowTime;
    const oneHourInMs = 60 * 60 * 1000;
    if (timeSinceLastShow < oneHourInMs) {
      return false;
    }
  }

  // เช็คว่าเข้าร่วมแล้วหรือยัง
  const hasJoined = localStorage.getItem("contestJoined");
  if (hasJoined === "true" || contestData.is_joined) {
    return false;
  }

  // เช็คสถานะ contest
  switch (contestData.status) {
    case "upcoming":
      return false;
    case "opening":
      return true;
    case "ended":
      return false;
    default:
      return false;
  }
};
